import React from "react";
import PropTypes from "prop-types";
import "./GenericBanner.css";
import * as FeatherIcon from "react-feather";

const GenericBanner = ({
  type = "info",
  message = "",
  component = null,
  onClose = null,
}) => {
  const getIcon = () => {
    switch (type) {
      case "success":
        return "✅";
      case "error":
        return <FeatherIcon.XCircle className="banner-icon"/>;
      case "info":
      default:
        return "ℹ️";
    }
  };

  return (
    <div className={`generic-banner generic-banner-${type}`}>
      <div className="banner-content">
         {getIcon()}
        {component ? (
          component
        ) : (
          <div className="banner-message">{message}</div>
        )}
      </div>
      {onClose && (
        <button className="banner-close" onClick={onClose}>
          ✖
        </button>
      )}
    </div>
  );
};

GenericBanner.propTypes = {
  type: PropTypes.oneOf(["success", "info", "error"]),
  message: PropTypes.string,
  component: PropTypes.node,
  onClose: PropTypes.func,
};

export default GenericBanner;
